import logoNoronCar from '../Images/logo.png';
import "./Login.css";
import loginLogo from '../Images/logoWeb.png';
import React, { useEffect, useState, useRef } from "react";
import config from "../config.json";
import { Link, useNavigate } from 'react-router-dom';
import http from "../Services/httpService";
import service from "../Services/services";
import { toast } from "react-toastify";

export default function Login() {
    const navigate = useNavigate();
    const [isPosting, setIsPosting] = useState(false);
    const formRef = useRef(null);

    // مقداردهی اولیه استاندارد فرم همراه با تنظیمات کانفیگ
    const [form, setForm] = useState({
        mobile: "",
        codeMeli: "",
        Username: "",
        Password: "",
        company: config?.Company || "",
        version: config?.Version || "1.0.0",
        year: config?.Year || ""
    });

    useEffect(() => {
        const jwt = http.getLocalJwt();
        if (jwt && jwt !== "") {
            navigate('/main');
        }
    }, [navigate]);

    const handlePosting = async (e) => {
        e.preventDefault();
        const forms = formRef.current;
        
        if (forms.checkValidity() === false) {
            toast.error('لطفاً شماره موبایل و کد ملی را به درستی وارد نمایید', { theme: "colored" });
            forms.classList.add('was-validated');
            return;
        }

        setIsPosting(true);
        try {
            const { data } = await service.RequestVerifyCode(form.mobile, form.codeMeli);
            setIsPosting(false);
            
            if (data.errorCode !== 0) {
                toast.error(data.message, { theme: "colored" });
                return;
            }

            // ارسال شماره موبایل و کد ملی به صفحه رمز یکبارمصرف
            navigate(`/PrivecyCode`, { 
                state: { 
                    mobile: form.mobile, 
                    codeMeli: form.codeMeli 
                } 
            });
        } catch (err) {
            setIsPosting(false);
        }
    };

    return (
        <div className="container-fluid bg-light min-vh-100 d-flex align-items-center justify-content-center p-3" dir="rtl">
            <div className="card shadow border-0 rounded-4 p-4 p-sm-5 bg-white text-center w-100" style={{ maxWidth: '440px' }}>

                {/* لوگو و سربرگ */}
                <div className="mb-4">
                    <img 
                        src={loginLogo} 
                        className="img-fluid mb-3" 
                        alt="لوگو کانون" 
                        style={{ maxHeight: '80px', objectFit: 'contain' }}
                    />
                    <h1 className="h4 fw-bold text-dark mb-1">
                        🏛️ ورود به سامانه کانون
                    </h1>
                    <p className="text-secondary small mb-0">
                        جهت دریافت کد تایید، شماره همراه و کد ملی خود را وارد نمایید
                    </p>
                </div>

                {/* فرم ورود */}
                <form ref={formRef} className="needs-validation" onSubmit={handlePosting} noValidate>
                    <div className="d-flex flex-column gap-3 text-start">
                        
                        {/* فیلد شماره همراه */}
                        <div>
                            <label className="form-label small fw-semibold text-secondary">
                                شماره موبایل <span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                                <span className="input-group-text bg-light border-end-0 text-muted" aria-hidden="true">📱</span>
                                <input
                                    type="tel"
                                    inputMode="numeric"
                                    className="form-control border-start-0 text-end"
                                    placeholder="۰۹xxxxxxxxx"
                                    required
                                    pattern="^09[0-9]{9}$"
                                    maxLength="11"
                                    autoComplete="tel"
                                    value={form.mobile}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    name="mobile"
                                />
                            </div>
                        </div>

                        {/* فیلد کد ملی */}
                        <div>
                            <label className="form-label small fw-semibold text-secondary">
                                کد ملی <span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                                <span className="input-group-text bg-light border-end-0 text-muted" aria-hidden="true">🪪</span>
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    className="form-control border-start-0 text-end"
                                    placeholder="۱۰ رقم کد ملی"
                                    required
                                    maxLength="10"
                                    value={form.codeMeli}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    name="codeMeli"
                                />
                            </div>
                        </div>

                        {/* دکمه درخواست کد تایید */}
                        <div className="mt-3">
                            <button
                                type="submit"
                                className="btn btn-primary w-100 py-3 rounded-3 d-flex align-items-center justify-content-center gap-2 shadow-sm"
                                disabled={isPosting}
                            >
                                {isPosting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        <span>در حال ارسال پیامک...</span>
                                    </>
                                ) : (
                                    <>
                                        <span className="fw-bold">دریافت کد تایید</span>
                                        <span aria-hidden="true">➜</span>
                                    </>
                                )}
                            </button>
                        </div>

                    </div>
                </form>

                {/* پیوند ثبت نام */}
                <div className="mt-4 pt-3 border-top">
                    <p className="text-secondary small mb-2">هنوز در سامانه عضو نشده‌اید؟</p>
                    <Link 
                        to="/register" 
                        className="btn btn-outline-secondary w-100 py-2 rounded-3 d-inline-flex align-items-center justify-content-center gap-2 text-decoration-none shadow-sm"
                    >
                        <img 
                            src={logoNoronCar} 
                            className="rounded-circle shadow-sm" 
                            style={{ width: '24px', height: '24px', objectFit: 'contain' }}
                            alt="ثبت نام" 
                        />
                        <span className="fw-bold">ثبت نام عضویت جدید</span>
                        <span aria-hidden="true">✍️</span>
                    </Link>
                </div>

                {/* فوتر نگارش و شرکت */}
                {(form.company || form.version || form.year) && (
                    <div className="text-center text-muted small opacity-75 mt-4 pt-2">
                        <span>{form.company}</span>
                        {form.year && <span className="mx-1">• {form.year}</span>}
                        {form.version && <span className="mx-1">• نسخه {form.version}</span>}
                    </div>
                )}

            </div>
        </div>
    );
}
